const TextArea = ({
  value,
  label,
  name,
  placeholder,
  type,
  onChange,
  rows,
  cols,
}) => (
  <div>
    {label && (
      <label
        htmlFor="input-field"
        className="mb-2 block text-sm font-medium text-[#5E5E5E]"
      >
        {label}
      </label>
    )}
    <textarea
      name={name}
      rows={rows}
      cols={cols}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="border-supportiveDarkGray text-supportiveBlack placeholder:text-supportiveGray4 focus:border-icon-color focus:outline-icon-color block w-full appearance-none border p-3 text-sm font-medium leading-tight placeholder:text-base focus:bg-white md:text-base"
    />
  </div>
);

export default TextArea;
